export class RemoveAdminAccessRequest {
    AdminID: number;
}
